import { clipboardWriteText, urlExtenAttributeId } from "@clover/ashe-libs";
import bridge from "@clover/bridge";
import queryString from "query-string";
import update from "../components/update/index";
import { getAppData, getAttribuiteId } from "../requset";
import testWatermark from "../assets/test-watermark.png";
import { DataInputNodeType, DataSource, IDataInputValueNode } from "@clover/ashe-core-runtime";
const OLD_SHARE_URL = process.env.VUE_APP_OLD_SHARE_URL;
const OLD_SHARE_EX_URL = process.env.VUE_APP_OLD_SHARE_EX_URL;

const query = new URLSearchParams(location.search);

export const getUrl = (type: "component" | "middleware" | "handler", version: string, name: string) => {
  return version.startsWith("http") ? version : `https://fe-cdn.soulapp.cn/ashe/plugins/${type}/${version}/${name}.js`;
};

export const toast = (text: string) => {
  const inner = isSoul();
  if (inner)
    bridge.toast({
      type: "error",
      text,
    });
  else alert(text);
};

export const checkCode = (code: number, message: string | null, jsonData: Record<string, any>): Record<string, any> => {
  return new Promise(async (resolve, reject) => {
    const dev = query.get("dev");
    const parseData = JSON.parse(jsonData.pageData);

    if (dev) return resolve(parseData);

    switch (code) {
      case 0:
        const { pageIdEcpt, activityIdEcpt, pageType } = jsonData;
        const searchStr = window.location.search as string;
        const query = queryString.parse(searchStr.replace("#/?", ""));
        query.pageIdEcpt = pageIdEcpt;
        query.activityIdEcpt = activityIdEcpt;

        if ([1, 2].includes(pageType)) {
          const shareUrl = pageType === 1 ? OLD_SHARE_URL : OLD_SHARE_EX_URL;
          const replaceUrl = `${shareUrl}#?${queryString.stringify(query)}`;
          window.location.replace(replaceUrl);
          return;
        } else {
          window.history.replaceState(null, "", `${window.location.pathname}?${queryString.stringify(query)}`);
        }

        resolve(parseData);
        break;
      case -1:
        toast(message || "哦~，服务器开小差了");
        reject();
        break;
      case 1:
        toast(message || "该活动已下线");
        reject();
        break;
      case 2:
        toast(message || "该活动暂未开始~");
        reject();
        break;
      case 3:
        update();
        reject();
        break;
      case 5:
        if (jsonData.defaultPageIdEcpt) {
          const { code, message, data } = await getAppData(jsonData.defaultPageIdEcpt);
          if (code === 0) resolve(JSON.parse(data.pageData));
          else checkCode(code, message, data);
          break;
        } else {
          toast(message || "该活动暂未开始~");
          return reject();
        }
      default:
        resolve(parseData);
    }
  });
};

export const isSoul = () => {
  return query.get("pageType") === "3";
};

export const titleHandler = (str: string) => {
  document.title = str;
  if (isSoul()) bridge.setNavigationTitle({ title: str });
};

export const injectionDiscernCodeclipboard = async () => {
  try {
    const searchStr = window.location.search as string;
    const query = queryString.parse(searchStr.replace("#/?", ""));
    const { attributeId, pageIdEcpt, pageType } = query;
    let code: string = attributeId as string;
    if (!attributeId && pageType === "4") {
      code = await getAttribuiteId(pageIdEcpt as string);
      const uu: any = queryString.parseUrl(window.location.href, { parseFragmentIdentifier: true });
      uu.query.attributeId = code;
      if (uu.query.pageIdEcpt !== "ZVQ2SGs1UjZ6Yms9") {
        // 排除乐乐茶活动
        window.location.href = queryString.stringifyUrl(uu);
      }
      // window.history.pushState('', window.document.title, queryString.stringifyUrl(uu));
    }
    if (code) {
      const handlerSetClipboard = () => {
        clipboardWriteText(code);
      };

      document.body.addEventListener("click", handlerSetClipboard, {
        once: true,
        capture: true,
      });
    }
  } catch (error) {}
};

export const browserEnv = {
  isOpenHarmony: Boolean(navigator.userAgent.match(/OpenHarmony/gi)),
  isAndroid: Boolean(navigator.userAgent.match(/android/gi)),
  isIphone: Boolean(navigator.userAgent.match(/iphone|ipod/gi)),
  isIpad: Boolean(navigator.userAgent.match(/ipad/gi)),
  isWeixin: Boolean(navigator.userAgent.match(/MicroMessenger/gi)),
  isAli: Boolean(navigator.userAgent.match(/AlipayClient/gi)),
};

interface IWeixinPlainObject {
  [key: string]: any;
}

export interface IWeixinResult {
  fail?: (res: IWeixinPlainObject) => void;
  cancel?: (res: IWeixinPlainObject) => void;
  trigger?: (res: IWeixinPlainObject) => void;
  success?: (res: IWeixinPlainObject) => void;
  complete?: (res: IWeixinPlainObject) => void;
}

export interface IWeixinShareOptions extends IWeixinResult {
  link?: string;
  title: string;
  desc?: string;
  imgUrl?: string;
}

const getShareUrl = (page: { protocol: string; host: string; pageType: number | string; activityIdEcpt: string; pageIdEcpt: string }) => {
  return `${page.protocol}:${page.host}/?${+page.pageType === 3 ? "disableShare=true&" : ""}activityIdEcpt=${page.activityIdEcpt}&pageIdEcpt=${
    page.pageIdEcpt
  }&pageType=${page.pageType}&off=1`;
};

export async function processUrlSetter(
  item: { type: "current-page" | "custom" | "page"; id?: string; url?: string } | string,
  flag?: false | undefined
) {
  if (typeof item === "string") {
    return flag === false ? item : await urlExtenAttributeId(item);
  } else {
    switch (item.type) {
      case "current-page":
        return flag === false ? location.href : await urlExtenAttributeId(location.href);
      case "custom":
        return flag === false ? item.url : await urlExtenAttributeId(item.url);
      case "page":
        if (item.id) {
          const [protocol, host, pageType, activityIdEcpt, pageIdEcpt] = item.id.split(":");
          return flag === false
            ? getShareUrl({ protocol, host, activityIdEcpt, pageIdEcpt, pageType })
            : await urlExtenAttributeId(getShareUrl({ protocol, host, activityIdEcpt, pageIdEcpt, pageType }));
        }
        return flag === false ? location.href : await urlExtenAttributeId(location.href);
    }
  }
}

const loadFonts = async (fontFace: { name: string; src: string; type: "file" }) => {
  try {
    if (fontFace.src && fontFace.name) {
      const style = document.createElement("style");
      style.innerHTML = `
      @font-face {
        font-family: ${fontFace.name};
        src: url("${fontFace.src}");
      }
    `;
      document.head.appendChild(style);
    }
  } catch (error) {
    console.error("loadFonts error:", error);
  }
};

export const initCommandStyle = (commandStyle: { fontFace: { name: string; src: string; type: "file" }[] }) => {
  try {
    commandStyle?.fontFace?.forEach((fontFace) => {
      loadFonts(fontFace);
    });
  } catch (error) {
    console.error("initCommandStyle", error);
  }
};

/**
 * 设置测试水印
 */
export const setTestWatermark = () => {
  const watermark = window.document.createElement("div");
  watermark.style.position = "fixed";
  watermark.style.top = "0";
  watermark.style.left = "0";
  watermark.style.right = "0";
  watermark.style.bottom = "0";
  watermark.style.zIndex = "9999";
  watermark.style.pointerEvents = "none";
  watermark.style.backgroundImage = `url(${testWatermark})`;
  window.document.body.appendChild(watermark);
};
